// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"H2-z","colorTextValue":"I2-z","swatches":"J2-z","collapseLink":"K2-z","isCollapsed":"L2-z","dropdown":"M2-z","disabled":"N2-z"};